import React, { useState, useEffect } from 'react';
import SmartTable, { SmartTableColumn } from '../../../shared/components/SmartTable';
import SmartTableButtons from '../../../shared/components/SmartTableButtons';
import LayoutWrapper from '../../../shared/components/LayoutWrapper';
import { useAuth } from '../../../shared/hooks/useAuth';
import api from '../../../shared/utils/api';
import ErrorPopup from '../../../shared/components/ErrorPopup';
import { loadCustomersForTaxHistory, Customer } from '../lib/CustomersLoadEntId';
import { fetchSalarySheet, createPayroll, createPayrollAllMonths, checkPayrollStatus, fetchSalarySheetData, fetchSalarySheetDataAllMonths, fetchCustomerEmployeeSalaryData } from '../lib/api';
import SalaryConfigurationPopup from '../components/SalaryConfigurationPopup';
import { getTokenInfo, logTokenInfo, setupTokens, checkAuthentication } from '../../../config/novaqToken';

interface Salary {
  Oid: string;
  SalaryOid: string;
  CustomerEmployeeId: string; // Database schema-тай тохирох
  InsureEmployeePercent: number; // Database schema-тай тохирох
  InsureEmployerPercent: number; // Database schema-тай тохирох
  InsureEmployeeAmount: number; // Database schema-тай тохирох
  InsureEmployerAmount: number; // Database schema-тай тохирох
  TaxableAmount: number;
  TaxAmount: number;
  TaxFreeAmount: number; // Database schema-д байгаа
  CashSalary: number; // Database schema-д байгаа
  Salary: number;
  PITaxAmount: number; // Database schema-тай тохирох
  // Frontend-д нэмэгдсэн field-ууд
  customerId?: string;
  customerName?: string;
  CreatedDate?: string; // Frontend-д ашиглагдаж байгаа
  [key: string]: any;
}




const defaultColumns: SmartTableColumn[] = [  
  { key: 'Oid', label: 'Цалингийн дугаар', width: 150 },
  { key: 'customerId', label: 'Харилцагчийн регистр', width: 150, render: (value) => (
    <div className="text-sm">
      {value || '-'}
    </div>
  )},
  { key: 'customerName', label: 'Харилцагчийн нэр', width: 200, render: (value) => (
    <div className="font-medium text-blue-600">
      {value || '-'}
    </div>
  )},
  { key: 'employeeCode', label: 'Ажилтны регистр', width: 150, render: (value) => (
    <div className="text-sm font-mono">
      {value || '-'}
    </div>
  )},
  { key: 'employeeLastName', label: 'Ажилтны овог', width: 150, render: (value) => (
    <div className="text-sm">
      {value || '-'}
    </div>
  )},
  { key: 'employeeName', label: 'Ажилтны нэр', width: 150, render: (value, isFooter) => (
    <div className={`text-sm font-medium ${isFooter ? 'font-bold bg-blue-50 text-blue-800' : ''}`}>
      {value || '-'}
    </div>
  )},
  { key: 'MonthCount', label: 'Цалин бодсон сарын тоо', width: 180, render: (value, isFooter) => (
    <div className={`text-sm text-center font-medium ${isFooter ? 'text-gray-500' : 'text-cyan-600'}`}>
      {value && value !== 'null' && value !== 'undefined' && !isNaN(parseInt(value)) ? `${value} сар` : '-'}
    </div>
  )},  
  { key: 'Salary', label: 'Цалин', width: 150, render: (value, isFooter) => (
    <div className={`font-medium ${isFooter ? 'text-green-800 font-bold bg-green-50' : 'text-green-600'}`}>
      {(value || 0).toLocaleString()} ₮
    </div>
  )},
  { key: 'InsureEmployeePercent', label: 'НДШ ажилтны хувь', width: 150, render: (value) => (
    <div className="text-sm text-center font-medium text-blue-600">
      {value && value !== 'null' && value !== 'undefined' ? `${value}%` : '-'}
    </div>
  )},
  { key: 'InsureEmployerPercent', label: 'НДШ ажил олгогчийн хувь', width: 180, render: (value) => (
    <div className="text-sm text-center font-medium text-purple-600">
      {value && value !== 'null' && value !== 'undefined' ? `${value}%` : '-'}
    </div>
  )},
  { key: 'InsureEmployeeAmount', label: 'НДШ ажилтны дүн', width: 150, render: (value, isFooter) => (
    <div className={`text-sm font-medium ${isFooter ? 'text-orange-800 font-bold bg-orange-50' : 'text-orange-600'}`}>
      {value && value !== 'null' && value !== 'undefined' && !isNaN(parseFloat(value)) ? `${parseFloat(value).toLocaleString()} ₮` : '-'}
    </div>
  )},
  { key: 'InsureEmployerAmount', label: 'НДШ ажил олгогчийн дүн', width: 180, render: (value, isFooter) => (
    <div className={`text-sm font-medium ${isFooter ? 'text-indigo-800 font-bold bg-indigo-50' : 'text-indigo-600'}`}>
      {value && value !== 'null' && value !== 'undefined' && !isNaN(parseFloat(value)) ? `${parseFloat(value).toLocaleString()} ₮` : '-'}
    </div>
  )},
  { key: 'TaxableAmount', label: 'Татварт ордог дүн', width: 160, render: (value, isFooter) => (
    <div className={`text-sm font-medium ${isFooter ? 'text-gray-800 font-bold bg-gray-50' : 'text-gray-700'}`}>
      {value && value !== 'null' && value !== 'undefined' && !isNaN(parseFloat(value)) ? `${parseFloat(value).toLocaleString()} ₮` : '-'}
    </div>
  )},
  { key: 'TaxAmount', label: 'Татварын дүн', width: 140, render: (value, isFooter) => (
    <div className={`text-sm font-medium ${isFooter ? 'text-red-800 font-bold bg-red-50' : 'text-red-600'}`}>
      {value && value !== 'null' && value !== 'undefined' && !isNaN(parseFloat(value)) ? `${parseFloat(value).toLocaleString()} ₮` : '-'}
    </div>
  )},
  { key: 'TaxFreeAmount', label: 'Татвараас чөлөөлөгдөх дүн', width: 180, render: (value, isFooter) => (
    <div className={`text-sm font-medium ${isFooter ? 'text-green-800 font-bold bg-green-50' : 'text-green-700'}`}>
      {value && value !== 'null' && value !== 'undefined' && !isNaN(parseFloat(value)) ? `${parseFloat(value).toLocaleString()} ₮` : '-'}
    </div>
  )},
  { key: 'CashSalary', label: 'Бэлэн цалин', width: 140, render: (value, isFooter) => (
    <div className={`text-sm font-medium ${isFooter ? 'text-emerald-800 font-bold bg-emerald-50' : 'text-emerald-600'}`}>
      {value && value !== 'null' && value !== 'undefined' && !isNaN(parseFloat(value)) ? `${parseFloat(value).toLocaleString()} ₮` : '-'}
    </div>
  )},
  { key: 'PITaxAmount', label: 'ХОАТ-ын дүн', width: 140, render: (value, isFooter) => (
    <div className={`text-sm font-medium ${isFooter ? 'text-pink-800 font-bold bg-pink-50' : 'text-pink-600'}`}>
      {value && value !== 'null' && value !== 'undefined' && !isNaN(parseFloat(value)) ? `${parseFloat(value).toLocaleString()} ₮` : '-'}
    </div>
  )},
  { key: 'OccupationCategoryCode', label: 'Мэргэжлийн ангилал', width: 150, render: (value) => (
    <div className="text-sm font-medium text-blue-600">
      {value || '-'}
    </div>
  )},
  { key: 'InsuranceCategoryCode', label: 'Даатгалын ангилал', width: 150, render: (value) => (
    <div className="text-sm font-medium text-purple-600">
      {value || '-'}
    </div>
  )},
];

const SalarySheet: React.FC = () => { 
  console.log('🚀 SalarySheet component is rendering...');
  
  const { userAuth } = useAuth();
  const [salaries, setSalaries] = useState<Salary[]>([]);
  const [salarySheetData, setSalarySheetData] = useState<Salary[]>([]);
  const [loading, setLoading] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedYear, setSelectedYear] = useState('2025');
  const [selectedMonth, setSelectedMonth] = useState('1');
  const [isAllMonths, setIsAllMonths] = useState(true); // Default: Бүх сар
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [showColumnSearch, setShowColumnSearch] = useState(false);
  const [footerData, setFooterData] = useState<any>(null);
  const [showColumnSettings, setShowColumnSettings] = useState(false);
  const [payrollLoading, setPayrollLoading] = useState(false);
  const [showSalaryConfigPopup, setShowSalaryConfigPopup] = useState(false);
  
  console.log('🚀 SalarySheet state:', {
    showColumnSearch,
    showColumnSettings,
    selectedYear,
    selectedMonth,
    customersCount: customers.length
  });


  const fetchSalaries = async () => {
    try {
      setLoading(true);
      console.log('🔥 SalarySheet: Starting to fetch salaries...');
      console.log('🔥 Selected year:', selectedYear);
      console.log('🔥 Selected month:', selectedMonth);
      console.log('🔥 Is all months:', isAllMonths);
      console.log('🔥 Selected customer:', selectedCustomer);
      
      // CustomerEmployeeSalary хүснэгтээс мэдээлэл авах (цалингийн тохиргоо)
      const year = parseInt(selectedYear);
      
      let salaryData;
      
      // Бүх сар сонгосон бол бүх сарын нийлбэр авах
      if (isAllMonths) {
        // Бүх сар сонгосон үед харилцагч сонгох шаардлагатай
        if (!selectedCustomer || !selectedCustomer.Oid) {
          setErrorMessage('Бүх сар сонгосон үед харилцагч сонгох шаардлагатай.');
          setShowErrorPopup(true);
          setSalaries([]);
          setLoading(false);
          return;
        }
        console.log(`📊 Fetching SalarySheet data for all months of ${year} он`);
        salaryData = await fetchSalarySheetDataAllMonths(year, selectedCustomer.Oid);
      } else {
        const month = parseInt(selectedMonth);
        // Бүх харилцагч сонгосон эсэхийг шалгах
        if (!selectedCustomer || !selectedCustomer.Oid) {
          // Бүх харилцагчийн мэдээлэл авах
          console.log(`📊 Fetching SalarySheet data for all customers - ${year} оны ${month} сар`);
          const response = await api.get(`/api/salary-sheet/data/${year}/${month}`);
          if (response.success && response.data) {
            salaryData = response.data;
            // Бүх харилцагчийн мэдээлэлд MonthCount нэмэх (нэг сар)
            salaryData = salaryData.map((item: any) => ({
              ...item,
              MonthCount: 1
            }));
          } else {
            salaryData = [];
          }
        } else {
          console.log(`📊 Fetching SalarySheet data for ${year} оны ${month} сар`);
          salaryData = await fetchSalarySheetData(year, month, selectedCustomer.Oid);
        }
      }
      
      if (salaryData && Array.isArray(salaryData)) {
        console.log(`✅ SalarySheet data fetched successfully: ${salaryData.length} records`);
        console.log('🔍 First record sample:', salaryData[0]);
        console.log('🔍 Selected customer:', selectedCustomer);
        
        // Debug: API-аас буцаж ирсэн өгөгдлийг дэлгэрэнгүй хэвлэх
        if (salaryData.length > 0) {
          console.log('🔍 API Response detailed check:');
          console.log('🔍 CustomerName:', salaryData[0].customerName || salaryData[0].CustomerName);
          console.log('🔍 EmployeeName:', salaryData[0].employeeName || salaryData[0].EmployeeName);
          console.log('🔍 EmployeeLastName:', salaryData[0].employeeLastName || salaryData[0].EmployeeLastName);
          console.log('🔍 EmployeeCode:', salaryData[0].employeeCode || salaryData[0].EmployeeCode);
          console.log('🔍 CustomerID:', salaryData[0].customerId || salaryData[0].CustomerID);
          console.log('🔍 Salary:', salaryData[0].Salary);
          console.log('🔍 MonthCount:', salaryData[0].MonthCount);
          console.log('🔍 IsAllMonths:', isAllMonths);
          console.log('🔍 All keys in first record:', Object.keys(salaryData[0]));
        }
        
        // Давхардсан мөрүүдийг арилгах
        // Зарим сард (жишээ нь 9-р сар) давхардсан мөр гарч болзошгүй
        // Нэг ажилтан нэг сард зөвхөн нэг цалингийн бүртгэлтэй байх ёстой
        // Тиймээс SalaryOid + CustomerEmployeeId-аар шүүж, давхардсан тохиолдолд хамгийн сүүлийнх нь үлдэнэ
        const uniqueMap = new Map<string, Salary>();
        
        salaryData.forEach((item) => {
          // SalaryOid + CustomerEmployeeId нь нэг ажилтны нэг сарын цалингийн бүртгэлийг илэрхийлнэ
          const uniqueKey = `${item.SalaryOid}_${item.CustomerEmployeeId}`;
          
          if (!uniqueMap.has(uniqueKey)) {
            uniqueMap.set(uniqueKey, item);
          } else {
            // Давхардсан мөр олдвол, хамгийн сүүлийнх нь (CreatedDate-аар) үлдэнэ
            const existing = uniqueMap.get(uniqueKey)!;
            const existingDate = existing.CreatedDate ? new Date(existing.CreatedDate).getTime() : 0;
            const currentDate = item.CreatedDate ? new Date(item.CreatedDate).getTime() : 0;
            
            if (currentDate > existingDate) {
              uniqueMap.set(uniqueKey, item);
            }
          }
        });
        
        const uniqueData = Array.from(uniqueMap.values());
        
        if (uniqueData.length !== salaryData.length) {
          console.log(`⚠️ Давхардсан мөр олдлоо: ${salaryData.length} -> ${uniqueData.length} мөр`);
          console.log('🔍 Давхардсан мөрүүдийн дэлгэрэнгүй:', {
            original: salaryData.length,
            unique: uniqueData.length,
            removed: salaryData.length - uniqueData.length,
            month: selectedMonth,
            year: selectedYear
          });
          
          // Давхардсан мөрүүдийг илрүүлэх
          const duplicateKeys = new Map<string, number>();
          salaryData.forEach((item) => {
            const key = `${item.SalaryOid}_${item.CustomerEmployeeId}`;
            duplicateKeys.set(key, (duplicateKeys.get(key) || 0) + 1);
          });
          
          const duplicates = Array.from(duplicateKeys.entries())
            .filter(([_, count]) => count > 1)
            .map(([key, count]) => ({ key, count }));
          
          if (duplicates.length > 0) {
            console.log('🔍 Давхардсан мөрүүд:', duplicates);
          }
        }
        
        setSalarySheetData(uniqueData);
        setSalaries(uniqueData); // Хуучин state-ийг ч шинэчлэх
        
        // Footer data тооцоолох (давхардлыг арилгасан өгөгдлөөр)
        if (uniqueData && uniqueData.length > 0) {
          const getNumber = (value: any): number => {
            if (typeof value === 'number') return value || 0;
            if (typeof value === 'string') return parseFloat(value) || 0;
            return 0;
          };
          
          const footer = {
            EmployeeName: 'НИЙЛБЭР',
            Salary: uniqueData.reduce((sum, item) => sum + getNumber(item.Salary), 0),
            InsureEmployeeAmount: uniqueData.reduce((sum, item) => sum + getNumber(item.InsureEmployeeAmount), 0),
            InsureEmployerAmount: uniqueData.reduce((sum, item) => sum + getNumber(item.InsureEmployerAmount), 0),
            TaxableAmount: uniqueData.reduce((sum, item) => sum + getNumber(item.TaxableAmount), 0),
            TaxAmount: uniqueData.reduce((sum, item) => sum + getNumber(item.TaxAmount), 0),
            TaxFreeAmount: uniqueData.reduce((sum, item) => sum + getNumber(item.TaxFreeAmount), 0),
            CashSalary: uniqueData.reduce((sum, item) => sum + getNumber(item.CashSalary), 0),
            PITaxAmount: uniqueData.reduce((sum, item) => sum + getNumber(item.PITaxAmount), 0),
          };
          setFooterData(footer);
        } else {
          setFooterData(null);
        }
      } else {
        console.log('⚠️ No SalarySheet data found for the selected period');
        setSalarySheetData([]);
        setSalaries([]);
      }
      
    } catch (error: any) {
      console.error('❌ Error fetching salary records:', error);
      console.error('❌ Error details:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      });
      
      let errorMessage = 'Цалингийн мэдээлэл авахад алдаа гарлаа';
      
      if (error.response?.status === 404) {
        errorMessage = 'API endpoint олдсонгүй. Сервертэй холбогдож чадсангүй.';
      } else if (error.response?.status === 401) {
        errorMessage = 'Нэвтрэх эрх шаардлагатай.';
      } else if (error.response?.status === 500) {
        errorMessage = 'Серверийн алдаа. Дахин оролдоно уу.';
      } else if (error.code === 'NETWORK_ERROR' || error.message.includes('Network Error')) {
        errorMessage = 'Сүлжээний алдаа. Сервер ажиллаж байгаа эсэхийг шалгана уу.';
      }
      
      setErrorMessage(errorMessage);
      setShowErrorPopup(true);
    } finally {
      setLoading(false);
    }
  };

  // Button handlers
  const handleToggleSearch = () => {
    console.log('🔍 Дэлгэрэнгүй хайлт товч дарагдлаа!');
    console.log('🔍 Одоогийн showColumnSearch:', showColumnSearch);
    setShowColumnSearch(prev => !prev);
    console.log('🔍 Шинэ showColumnSearch:', !showColumnSearch);
  };

  const handleColumnSettings = () => {
    console.log('⚙️ Багана тохиргоо товч дарагдлаа!');
    console.log('⚙️ Одоогийн showColumnSettings:', showColumnSettings);
    setShowColumnSettings(prev => !prev);
    console.log('⚙️ Шинэ showColumnSettings:', !showColumnSettings);
  };

  const handleRefresh = () => {
    console.log('🔄 Сэргээх товч дарагдаж, өгөгдөл дахин ачаалж байна...');
    console.log('🔄 Selected year:', selectedYear);
    console.log('🔄 Selected month:', selectedMonth);
    fetchSalaries();
  };

  const handleSalaryConfiguration = () => {
    console.log('⚙️ Цалингийн тохиргоо товч дарагдлаа!');
    // Open popup - user will select employee from dropdown
    setShowSalaryConfigPopup(true);
  };

  // Цалин бодолт процедур дуудах функц
  const handleCreatePayroll = async () => {
    try {
      setPayrollLoading(true);
      console.log('💰 Цалин бодолт процедур дуудаж байна...');
      console.log('💰 Year:', selectedYear, 'Month:', selectedMonth, 'IsAllMonths:', isAllMonths);
      console.log('💰 Selected Customer:', selectedCustomer);
      
      const year = parseInt(selectedYear);
      
      // Харилцагч сонгосон эсэхийг шалгах
      if (!selectedCustomer || !selectedCustomer.Oid) {
        setErrorMessage('Эхлээд харилцагч сонгоно уу.');
        setShowErrorPopup(true);
        setPayrollLoading(false);
        return;
      }
      
      let result;
      
      // Бүх сар сонгосон эсэхийг шалгах
      if (isAllMonths) {
        console.log('💰 Бүх сарын цалин бодолт эхэлж байна...');
        result = await createPayrollAllMonths(selectedCustomer.Oid, year);
        
        if (result.success) {
          console.log('✅ Бүх сарын цалин бодолт амжилттай хийгдлээ:', result);
          const data = result.data || {};
          const successCount = data.successCount || 0;
          const skippedCount = data.skippedCount || 0;
          const errorCount = data.errorCount || 0;
          const totalRecords = data.totalRecords || 0;
          
          let message = `${selectedCustomer.CustomerName} - ${year} оны бүх сарын цалин бодолт дууслаа.\n`;
          message += `Амжилттай: ${successCount} сар, Алгассан: ${skippedCount} сар, Алдаатай: ${errorCount} сар\n`;
          message += `Нийт мөр: ${totalRecords}`;
          
          setErrorMessage(message);
          setShowErrorPopup(true);
          
          // Амжилттай болсны дараа өгөгдлийг дахин ачааллах
          setTimeout(() => {
            fetchSalaries();
          }, 2000);
        } else {
          console.error('❌ Бүх сарын цалин бодолт хийхэд алдаа гарлаа:', result);
          setErrorMessage(result.message || 'Бүх сарын цалин бодолт хийхэд алдаа гарлаа.');
          setShowErrorPopup(true);
        }
      } else {
        // Нэг сарын цалин бодолт
        const month = parseInt(selectedMonth);
        result = await createPayroll(year, month);
        
        if (result.success) {
          console.log('✅ Цалин бодолт амжилттай хийгдлээ:', result);
          
          setErrorMessage(`${selectedCustomer.CustomerName} - ${year} оны ${month} сарын цалин бодолт амжилттай хийгдлээ.`);
          setShowErrorPopup(true);
          
          // Амжилттай болсны дараа өгөгдлийг дахин ачааллах
          setTimeout(() => {
            fetchSalaries();
          }, 1000);
        } else {
          console.error('❌ Цалин бодолт хийхэд алдаа гарлаа:', result);
          setErrorMessage(result.message || 'Цалин бодолт хийхэд алдаа гарлаа.');
          setShowErrorPopup(true);
        }
      }
    } catch (error) {
      console.error('❌ Цалин бодолт процедурын алдаа:', error);
      setErrorMessage('Цалин бодолт процедур дуудахад алдаа гарлаа.');
      setShowErrorPopup(true);
    } finally {
      setPayrollLoading(false);
    }
  };

  useEffect(() => {
    // Эхлэхэд customer-ийн жагсаалт авах
    loadCustomersForTaxHistory(setCustomers, setSelectedCustomer, setLoading, setErrorMessage, setShowErrorPopup);
  }, []);

  useEffect(() => {
    // Token шалгах
    const auth = checkAuthentication();
    if (!auth.isAuthenticated) {
      console.log('❌ No valid token found');
      return;
    }
    
    // Харилцагч сонгосон эсэхийг шалгах
    if (!selectedCustomer || !selectedCustomer.Oid) {
      return;
    }
    
    // Шинэ API ашиглан SalarySheet мэдээлэл авах
    fetchSalaries();
  }, [selectedYear, selectedMonth, selectedCustomer, isAllMonths]);

  // Debug effect to log when SmartTableButtons props change
  useEffect(() => {
    console.log('🔥 SmartTableButtons props changed:', {
      showColumnSearch,
      onToggleSearch: typeof handleToggleSearch,
      onColumnSettings: typeof handleColumnSettings,
      onRefresh: typeof handleRefresh,
      addable: false
    });
  }, [showColumnSearch, handleToggleSearch, handleColumnSettings, handleRefresh]);

  return (
    <LayoutWrapper userAuth={userAuth}>
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Цалин бодолт</h1>
          
          {/* Action Buttons */}
          <SmartTableButtons
            showColumnSearch={showColumnSearch}
            onToggleSearch={handleToggleSearch}
            onColumnSettings={handleColumnSettings}
            onRefresh={handleRefresh}
            addable={false}
            salaryConfigButton={{
              label: '⚙️ Цалингийн тохиргоо',
              onClick: handleSalaryConfiguration
            }}
          />
      </div>



        {/* Year and Month Selection */}
        <div className="flex gap-4 mb-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Жил сонгох
            </label>
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              {Array.from({ length: 10 }, (_, i) => {
                const year = new Date().getFullYear() - i;
                return (
                  <option key={year} value={year.toString()}>
                    {year}
                  </option>
                );
              })}
            </select>
          </div>
          
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Сар сонгох
            </label>         
            <select
              value={isAllMonths ? 'all' : selectedMonth}
              onChange={(e) => {
                if (e.target.value === 'all') {
                  setIsAllMonths(true);
                  setSelectedMonth('1'); // Default value, won't be used
                } else {
                  setIsAllMonths(false);
                  setSelectedMonth(e.target.value);
                }
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="all">Бүх сар</option>
              {Array.from({ length: 12 }, (_, i) => {
                const month = i + 1;
                return (
                  <option key={month} value={month.toString()}>
                    {month}-р сар
                  </option>
                );
              })}
            </select>
          </div>
          
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Харилцагч сонгох
            </label>
            <select
              value={selectedCustomer?.Oid || ''}
              onChange={(e) => {
                const customer = customers.find(cust => cust.Oid === e.target.value);
                setSelectedCustomer(customer || null);
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              {customers.map((customer, index) => (
                <option key={`${customer.Oid}-${index}`} value={customer.Oid}>
                  {customer.CustomerName} ({customer.CustomerID})
                </option>
              ))}
            </select>
          </div>
          
          {/* Цалин бодолт товч */}
          <div className="flex items-end">
            <button
              onClick={handleCreatePayroll}
              disabled={payrollLoading}
              className={`px-6 py-2 rounded-md font-medium text-white transition-colors duration-200 ${
                payrollLoading
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2'
              }`}
            >
              {payrollLoading ? (
                <div className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Бодож байна...
                </div>
              ) : (
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Цалин бодолт
                </div>
              )}
            </button>
          </div>
        </div>

        <SmartTable
          data={salarySheetData}
          columns={defaultColumns}
          fetchData={fetchSalaries}
          settingsKey="salary-table"
          editable={false}
          addable={false}
          rowKey="Oid"
          showColumnSearch={showColumnSearch}
          showColumnSettings={showColumnSettings}
          footerData={footerData}
        />
        


        <ErrorPopup
          isVisible={showErrorPopup}
          message={errorMessage}
          onClose={() => setShowErrorPopup(false)}
        />

        {/* Salary Configuration Popup */}
        <SalaryConfigurationPopup
          isVisible={showSalaryConfigPopup}
          onClose={() => {
            setShowSalaryConfigPopup(false);
          }}
          initialYear={parseInt(selectedYear)}
          onSaveSuccess={() => {
            // Refresh salary data after successful save
            fetchSalaries();
          }}
        />
      </div>
    </LayoutWrapper>
  );
};

export default SalarySheet;
